<template>
  <div>
    <div class="banner-box">
      <h1>客户案例</h1>
      <p>
        集存储、计算、分析、管理于一体的智慧生态体系.<br />
        在中心的基础上围绕日常运作，实现信息化，智能管理的一款云系统，通过核心算法为临床科室治疗提供<br />
        智能方案，为医师决策提供及时辅助信息， 也为后期科研提供信息依据
      </p>
    </div>
    <p class="img-box">
      <img src="../assets/imgs/case-img-title.png" alt="" />
    </p>
    <div class="wrap">
      <div
        v-for="(item, index) in 9"
        :key="index"
        :style="{ marginRight: (index + 1) % 3 == 0 ? 0 : '110px' }"
      >
        <!-- <img src="../assets/imgs/news-exp.png" alt="" />
        <div class="down">
          <p class="name">凤翔县医院</p>
          <p class="desc">
            {{
              $overflow(
                "遂宁市民康医院隶属于市民政局，同时挂有“遂宁市优抚医院”、“遂宁市第六人民医院”。",
                50
              )
            }}
          </p>
        </div> -->
      </div>
    </div>
    <el-pagination
      prev-text="上一页"
      next-text="下一页"
      layout="prev, pager, next"
      :total="1000"
      class="pc"
    >
    </el-pagination>
    <p class="more mobile">点击加载更多</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.banner-box {
  padding-top: 80px;
  background-image: url("../assets/imgs/case-banner.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 400px;
  box-sizing: border-box;
  p,
  h1 {
    text-align: center;
  }
  h1 {
    font-size: 60px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 50px;
  }
  p {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
  }
}
.img-box {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 30px;
}
.wrap {
  display: flex;
  flex-wrap: wrap;
  & > div {
    width: 324px;
    box-shadow: 0px 3px 7px 0px rgba(49, 48, 48, 0.03);
    border-radius: 5px;
    margin-bottom: 40px;
    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      vertical-align: middle;
    }
    .down {
      width: 100%;
      height: 120px;
      padding: 15px 10px;
      box-sizing: border-box;
      .name {
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #42aab2;
        margin-bottom: 20px;
        overflow: hidden;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .desc {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #656565;
        line-height: 26px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }
}
@media (max-width: 760px) {
  .banner-box {
    height: unset;
    padding: 0.54rem 0.92rem;
    h1 {
      font-size: 0.36rem;
      margin-bottom: 0.37rem;
    }
    p {
      font-size: 0.18rem;
      line-height: 0.36rem;
    }
  }
  .img-box {
    margin-top: 0.23rem;
    margin-bottom: 0.31rem;
    font-size: 0;
    img {
      height: 0.47rem;
    }
  }
  .wrap {
    padding: 0 0.31rem;
    box-sizing: border-box;
    & > div {
      width: 100%;
      display: flex;
      margin-right: 0 !important;
      img {
        width: 2.2rem;
        height: 1.34rem;
      }
      .down {
        padding: 0.13rem 0.2rem;
        box-sizing: border-box;
        height: unset;
        .name {
          font-size: 0.22rem;
          text-align: left;
          margin-bottom: 0.23rem;
        }
        .desc {
          font-size: 0.2rem;
          line-height: 0.26rem;
        }
      }
    }
  }
}
</style>
